import template from "./pGroups.html";

export function pGroupsDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pGroupsController,
    controllerAs: 'pGroups',
    bindToController: true
  };

  return directive;
}

class pGroupsController {
  constructor(Auth, Admin, $scope, $interval, Notes, $translate, ConnectionQuality) {
    'ngInject';

    this.Auth = Auth;
    this.Admin = Admin;
    this.$scope = $scope;
    this.$interval = $interval;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.$translate = $translate;

    this.init();

    this.fields = {
      name: "info"
    };

    this.actions = [
      {
        name: "new",
        functionName: "startAddingNewGroup",
        fa: "fa-plus"
      }
    ];

    this.rowActions = [
      {
        name: "edit",
        functionName: "startEditingGroup",
        fa: "fa-pencil-alt"
      },
      {
        name: "delete",
        functionName: "startDeletingGroup",
        fa: "fa-trash"
      }
    ];

    /*
    * b-dalog-card data
    */

    this.groupData = {
      name: {
        type: 'text'
      }
    };

    this.$scope.$watch(() => this.newGroupProcess, (prev, curr) => {
      if (prev === true && !curr)
        this.validationErrorMessage = null;
    });

    this.$scope.$watch(() => this.editGroupProcess, (prev, curr) => {
      if (prev === true && !curr)
        this.validationErrorMessage = null;
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  init() {
    this.state = 'loading';
    this.Auth.authorizeAdmin().then(
      (user) => {
        this.user = user;
        if (!this.user.isAdmin) {
          this.Auth.handleUnauthorized();
        }
        this.Admin.getGroups().then(
          (success) => {
            this.groups = success.data.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }

              return 0;
            });
            this.state = 'loaded';
          },
          (error) => {
            this.state = 'loaded';
            this.Notes.postNote({type: "error", error: error});
          }
        );

        var timeout = this.$interval(() => {
          this.notes = this.Notes.getNotes();
        }, 10);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout);});
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );
  }

  startAddingNewGroup() {
    this.newGroupProcess = true;
    this.newGroupValues = null;
  }

  addGroup(group) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.addGroup(group).then(
      () => {
        this.newGroupProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startEditingGroup(group) {
    this.editGroupProcess = true;
    this.editGroupValues = angular.fromJson(angular.toJson(group));
  }

  updateGroup(group) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.updateGroup(group.id, group).then(
      () => {
        this.editGroupProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  startDeletingGroup(group) {
    this.deleteGroupProcess = true;
    this.deleteGroupValues = group;
  }

  deleteGroup(group) {
    if (this.state == 'loading')
      return;

    this.state = 'loading';

    this.Admin.deleteGroup(group.id).then(
      () => {
        this.deleteGroupProcess = false;
        this.init();
      },
      (error) => {
        this.state = 'loaded';
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  formInvalid(values) {
    if (!values || !values.name) {
      if (values && !values.name)
        this.validationErrorMessage = null;

      return true;
    }
    // eslint-disable-next-line no-control-regex
    const blacklistedCharacters = /[#%&{}\\<>*?/$!'":@+`|=()]/g;
    const matchValue = values.name && values.name.match(blacklistedCharacters);
    if (matchValue && matchValue.length > 0) {
      this.validationErrorMessage = this.$translate.instant("GROUPS.VALIDATION_ERROR");
      return true;
    }
    else {
      this.validationErrorMessage = null;
      return false;
    }
  }
}
